import { ButtonV2 } from 'ui/ButtonV2';
import { styled } from '@mui/material';
import { blendColors, manipulateColor } from 'lib/helpers';

export const MenuInfoButton = styled(ButtonV2, { shouldForwardProp: prop => prop !== 'desktop' })<{
    desktop: boolean;
}>(({ theme, desktop }) => ({
    fontFamily: `SecondaryFont, ${theme.typography.fontFamily}`,
    marginTop: 0,
    justifyContent: 'space-between',
    borderWidth: desktop ? 0 : 2,
    borderColor: desktop ? theme.palette.background.default : theme.palette.primary.main,
    fontSize: '1rem',
    backgroundColor: desktop
        ? blendColors(theme.palette.primary.main, theme.palette.primary.contrastText, 0.9)
        : undefined,
    color: desktop ? manipulateColor(theme.palette.primary.main, 0.8) : undefined
}));
